@import "tailwindcss";
@import "tw-animate-css";
@import "shadcn/tailwind.css";
@import "@fontsource-variable/geist";

@custom-variant dark (&:is(.dark *));

@theme inline {
    --font-heading: var(--font-sans);
    --font-sans: 'Geist Variable', sans-serif;
    --color-sidebar-ring: var(--sidebar-ring);
    --color-sidebar-border: var(--sidebar-border);
    --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
    --color-sidebar-accent: var(--sidebar-accent);
    --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
    --color-sidebar-primary: var(--sidebar-primary);
    --color-sidebar-foreground: var(--sidebar-foreground);
    --color-sidebar: var(--sidebar);
    --color-chart-5: var(--chart-5);
    --color-chart-4: var(--chart-4);
    --color-chart-3: var(--chart-3);
    --color-chart-2: var(--chart-2);
    --color-chart-1: var(--chart-1);
    --color-ring: var(--ring);
    --color-input: var(--input);
    --color-border: var(--border);
    --color-destructive: var(--destructive);
    --color-accent-foreground: var(--accent-foreground);
    --color-accent: var(--accent);
    --color-muted-foreground: var(--muted-foreground);
    --color-muted: var(--muted);
    --color-secondary-foreground: var(--secondary-foreground);
    --color-secondary: var(--secondary);
    --color-primary-foreground: var(--primary-foreground);
    --color-primary: var(--primary);
    --color-popover-foreground: var(--popover-foreground);
    --color-popover: var(--popover);
    --color-card-foreground: var(--card-foreground);
    --color-card: var(--card);
    --color-foreground: var(--foreground);
    --color-background: var(--background);
    --radius-sm: calc(var(--radius) * 0.6);
    --radius-md: calc(var(--radius) * 0.8);
    --radius-lg: var(--radius);
    --radius-xl: calc(var(--radius) * 1.4);
    --radius-2xl: calc(var(--radius) * 1.8);
    --radius-3xl: calc(var(--radius) * 2.2);
    --radius-4xl: calc(var(--radius) * 2.6);
}

:root {
    --background: oklch(0.97 0 0);
    --foreground: oklch(0.15 0 0);
    --card: oklch(1 0 0);
    --card-foreground: oklch(0.15 0 0);
    --popover: oklch(1 0 0);
    --popover-foreground: oklch(0.15 0 0);
    --primary: oklch(0.15 0 0);
    --primary-foreground: oklch(0.98 0 0);
    --secondary: oklch(0.96 0 0);
    --secondary-foreground: oklch(0.15 0 0);
    --muted: oklch(0.95 0 0);
    --muted-foreground: oklch(0.5 0 0);
    --accent: oklch(0.95 0 0);
    --accent-foreground: oklch(0.15 0 0);
    --destructive: oklch(0.577 0.245 27.325);
    --border: oklch(0.9 0 0);
    --input: oklch(0.9 0 0);
    --ring: oklch(0.55 0.12 250);
    --radius: 0.625rem;
    --sidebar: oklch(0.95 0 0);
    --sidebar-foreground: oklch(0.15 0 0);
    --sidebar-primary: oklch(0.15 0 0);
    --sidebar-primary-foreground: oklch(0.98 0 0);
    --sidebar-accent: oklch(1 0 0);
    --sidebar-accent-foreground: oklch(0.15 0 0);
    --sidebar-border: oklch(0.9 0 0);
    --sidebar-ring: oklch(0.55 0.12 250);
}

@layer base {
  * {
    @apply border-border outline-ring/50;
  }
  body {
    @apply bg-background text-foreground antialiased;
  }
  html {
    @apply font-sans;
  }
}
